<template>
    <div>
        <iframe src="/apps/dyson-sphere-game/index.html" width="100%" height="800px" frameborder="0"></iframe>
        <div id="header">
            <h1>Dyson Sphere</h1>
        </div>
        <div id="content">
            <div id="summary">
                <h3>Story summary</h3>
                <p>In a distant future, humanity has finally elevated from <a href="https://en.wikipedia.org/wiki/Kardashev_scale">Type 1 civilization to Type 2</a> by building a super structure known as the <a href="https://en.wikipedia.org/wiki/Dyson_sphere">Dyson Sphere</a>. With it, humans are able to harness the entire energy output of the Sun. But this development has not gone unnoticed. Other hostile alien races sees this new structure as a threat and are determined to destroy it, no matter what. As a countermeasure, You have been selected to defend the Sphere from the attackers. Fortunately, the aliens are not very bright and their only method of attacking is ramming their ships towards the Sphere. Unfortunately, there are seemingly infinite number of them. Destroy as many as you can and try to survive as long as possible.</p>
                <p>TL:DR<br>Defend the Sphere against endless hordes of hostile alien ships. Defeat if inevitable.</p>
            </div>
            <div id="control">
                <h4>Controls</h4>
                <ul>
                    <li>Mouse : Move camera and the defender around the Sphere</li>
                    <li>Left mouse button : Fire weapons</li>
                    <li>Spacebar : Activate an unbreakable Shield that obliterates anything that touches it. Consumes energy while active and when being hit. Replenishes slowly over time.</li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import { i18nMixin } from "@/vue/mixins/i18nMixin";

export default {
    mixins: [
        i18nMixin
    ],
    methods: {},
    data() {
        return {}
    },
        metaInfo: {
        meta: [
            { charset: 'utf-8' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' },
            { content: 'Dyson', property: 'og:title' }
        ]
    }
}
</script>

<style lang="scss" scoped>
</style>

<i18n>
{
    "en": {
        "pageTitle": "Dyson Sphere",
        "description": ""
    },
    "fi": {
        "pageTitle": "Dyson Sphere",
        "description": ""
    }
}
</i18n>
